import {Button, Dropdown, Menu} from 'antd';
import React, {useState, FC} from 'react';

import {ReactComponent as MoreIcon} from 'shared/assets/more.svg';

import {TableAction} from '../table-action';
import {TABLE_ACTION_MAP} from '../table-action-constants';
import {ITableActionProps} from '../table-action-types';

import './table-submenu-action.less';

export const TableSubmenuAction: FC<ITableActionProps> = ({meta, entityName}: ITableActionProps) => {
    const [visible, setVisible] = useState(false);

    const generateMenu = () => (
        <Menu>
            {meta.childrens?.map(child => (
                TABLE_ACTION_MAP[child.actionType] ? (
                    <TableAction
                        key={child.actionTitle}
                        meta={child}
                        wrapper={Menu.Item}
                        entityName={entityName}
                        closeTableSubmenu={() => setVisible(false)}
                    />
                ) : (
                    <Menu.Item
                        key={child.actionTitle}
                    >
                        {child.actionTitle}
                    </Menu.Item>
                )
            ))}
        </Menu>
    );

    return (meta?.childrens?.length ? (
        <Dropdown
            className="dropdown"
            overlay={generateMenu()}
            visible={visible}
            onVisibleChange={setVisible}
        >
            <Button className="table-action submenu-button">
                <MoreIcon className="dropdown__icon" />
            </Button>
        </Dropdown>
    ) : <></>);
};
